import { Navigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { REDIRECT_PARAM } from '$constants'
import HeaderRoute from '$components/HeaderRoute'
import { CenteredSpinner } from '$components/Spinner'
import { useToken } from '$context/user'

const ProtectedRoute = ({ current, setCurrent }) => {
  const { loginInProgress, token } = useToken()
  const { t } = useTranslation()
  const location = useLocation()

  if (loginInProgress) {
    return <CenteredSpinner message={t('please wait, authenticating')} />
  }
  const intendedPath = `${location.pathname}${location.search}${location.hash}`

  return token ? (
    <HeaderRoute currentRoute={current} setCurrentRoute={setCurrent} />
  ) : (
    <Navigate
      to={`/login${
        intendedPath && intendedPath !== '/'
          ? `?${REDIRECT_PARAM}=${encodeURIComponent(intendedPath)}`
          : ''
      }`}
      replace
    />
  )
}

export default ProtectedRoute
